/**
 * Comments service
 */

import Resource from './resource'

export default new Resource('comments')



// WEBPACK FOOTER //
// ./src/libraries/services/comments.js